const state = {
    riskModels: null,
    riskModel: null,
    riskComponents: null,
    riskComponent: null,
    riskDescriptionHeaders: null,
    riskDescriptionBodies: null,
    riskTypes: null,
    riskType: null,
    riskTypeDetail: null,
    riskAppetiteStatements: null,
};

const mutations = {
    setRiskModels(state, value) {
        state.riskModels = value;
    },
    setRiskModel(state, value) {
        state.riskModel = value;
    },
    setRiskComponents(state, value) {
        state.riskComponents = value;
    },
    setRiskComponent(state, value) {
        state.riskComponent = value;
    },
    setRiskDescriptionHeaders(state, value) {
        state.riskDescriptionHeaders = value;
    },
    setRiskDescriptionBodies(state, value) {
        state.riskDescriptionBodies = value;
    },
    setRiskTypes(state, value) {
        state.riskTypes = value;
    },
    setRiskType(state, value) {
        state.riskType = value;
    },
    setRiskTypeDetailBodies(state, value) {
        state.riskTypeDetail = value;
    },
    setRiskAppetiteStatements(state, value) {
        state.riskAppetiteStatements = value;
    },
};

const actions = {};

const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
